// DS: C16A
/** An editor content viewer for comments */ import _extends from "@swc/helpers/src/_extends.mjs";
import React from 'react';
import BaseViewer from './Base';
import commentsTheme from '../Themes/Viewer/comments.scss';
const CommentViewer = (props)=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: 'da-editor-comments'
    }, /*#__PURE__*/ React.createElement(BaseViewer, _extends({
        theme: commentsTheme,
        showMediaAlwaysSmall: true,
        fixedParagraph: false
    }, props)));
};
export default CommentViewer;
